import * as yup from 'yup'

const schemaCoupon = () =>
  yup.object().shape({
    name: yup.string().required(),
    groupId: yup.string().required(),
  })

export default schemaCoupon
